<template>
  <div style="margin-top: 70px">
    <v-container class="mt-5">
      <v-layout text-center wrap>
        <v-flex xs12>
          <!-- <v-card style="border-radius: 26px" outlined tile rounded class="ma-auto grey darken-3">  -->
          <v-card style=" width: auto" flat rounded class="ma-auto">
            <!-- <v-layout row> -->
            <v-form @submit.prevent="goToMassTortMatterFromSearch">
              <v-autocomplete
                label="search"
                outlined
                rounded
                clearable
                solo
                autofocus
                class="ma-auto"
                append-icon="mdi-magnify"
                :items="massTortMatters"
                item-text="caseName"
                item-value="matterID"
                v-model="slug"
                style="max-width: 500px"
              ></v-autocomplete>
            </v-form>

            <!-- <v-btn class="green" @click="goToMatterFromSearch">GO</v-btn> -->
            <!-- </v-layout> -->

            <v-card-text class="display-1 font-weight-light"
              >MASS TORT MATTERS</v-card-text
            >
            <v-card
              flat
              filled
              style="
          border-radius: 26px;
          border: 1px solid #18CAE6;
        "
              class="ma-auto"
            >
              <v-list
                class="ma-auto"
                style="border-radius: 26px; overflow: scroll"
                height="60vh"
              >
                <v-list-item
                  v-for="(matter, index) in massTortMatters"
                  :key="index"
                  class="ma-2"
                >
                  <v-flex>
                    <v-card
                      @click="goToMassTortMatter(matter.matterID)"
                      class="ma-3"
                      flat
                      outlined
                      style="border-radius: 26px; border: 1px solid #18CAE6"
                    >
                      <v-list-item-content>
                        <v-layout row class="ma-3">
                          <v-icon
                            small
                            rounded
                            dark
                            color="yellow"
                            v-if="
                              !matter.contentsListCompleted ||
                                matter.contentsListCompleted === false
                            "
                            >mdi-circle-slice-4</v-icon
                          >
                          <v-icon
                            small
                            rounded
                            dark
                            color="green"
                            v-if="
                              matter.contentsListCompleted &&
                                matter.contentsListCompleted === true
                            "
                            >mdi-circle-slice-8</v-icon
                          >
                          <div>
                            <v-list-item-title class="font-weight-bold">
                              {{ matter.id }}
                            </v-list-item-title>
                            <v-list-item-title class="font-weight-bold">
                              {{ matter.caseName }}
                            </v-list-item-title>
                            <v-list-item-subtitle class="mt-1">
                              DATE OF LOSS:
                              {{ matter.dateOfLoss }}
                            </v-list-item-subtitle>
                          </div>
                          <v-spacer></v-spacer>

                          <v-spacer></v-spacer>
                          <div>
                            <v-btn small rounded dark>
                              <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                          </div>
                        </v-layout>
                      </v-list-item-content>
                    </v-card>
                  </v-flex>
                </v-list-item>
              </v-list>
            </v-card>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import * as firebase from "firebase";
export default {
  data: () => ({
    slug: null,
    massTortMatters: []
  }),
  methods: {
    goToMassTortMatter(matterId) {
      let matter = this.massTortMatters.find(
        matter => matter.matterID === matterId
      );
      if (matter.propertySlug) {
        this.$router.push({
          name: "MassTortMatter",
          params: { id: matterId, type: "fire" }
        });
      }
    },
    goToMassTortMatterFromSearch() {
      let matter = this.massTortMatters.find(
        matter => matter.matterID === this.slug
      );
      if (matter.propertySlug) {
        this.$router.push({
          name: "MassTortMatter",
          params: { id: this.slug, type: "fire" }
        });
      }
    }
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    role() {
      return this.$store.getters.role;
    }
  },
  watch: {
    user(val) {
      if (val !== null && val !== undefined) {
        if (this.role === "admin") {
          let fireMatterRef = firebase
            .firestore()
            .collection("fireMatters")
            .where("sharedWith", "array-contains", val.email);

          fireMatterRef.onSnapshot(res => {
            res.forEach(doc => {
              this.massTortMatters.push({ ...doc.data(), id: doc.id });
            });
            // console.log(
            //   "from mass tort component - this is the res from onSnapshot res.data()",
            //   this.massTortMatters
            // );
          });
        } else {
          console.log("no user ");
        }
      }
    }
  },
  created() {
    if (this.role === "admin") {
      let fireMatterRef = firebase
        .firestore()
        .collection("fireMatters")
        .where("sharedWith", "array-contains", this.user.email);

      fireMatterRef.onSnapshot(res => {
        res.forEach(doc => {
          this.massTortMatters.push({ ...doc.data(), id: doc.id });
        });
        // console.log(
        //   "from mass tort component - this is the res from onSnapshot res.data()",
        //   this.massTortMatters
        // );
      });
    } else {
      console.log("no user ");
    }
    // if (this.role === "admin") {
    //   let fireMatterRef = firebase
    //     .firestore()
    //     .collection("fireMatters")
    //     .where("sharedWith", "array-contains", this.user.email);
    //   fireMatterRef.get()(res => {
    //     this.massTortMatters = res.data();
    //     console.log(
    //       "from mass tort component - this is the res from onSnapshot res.data()",
    //       this.massTortMatters
    //     );
    //   });
    // } else {
    //   console.log("no user ");
    // }
  }
};
</script>

<style></style>
